/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Loading } from '../Loading';
import { Pagination } from '../../shared/Constants';
import { intlShape } from '../prop-types';

export const Gr8piDataTableHeader = ({ children }) => (
  <div className="list-group-item list-group-header row">{children}</div>
);

Gr8piDataTableHeader.propTypes = {
  children: PropTypes.objectOf(PropTypes.any).isRequired,
};

export const Gr8piDataTableBody = ({ header, data, footer }) => (
  <div className="panel panel-default">
    <div className="panel-body">
      <div className="list-group">
        {header}
        {data}
      </div>
    </div>

    {footer}
  </div>
);

Gr8piDataTableBody.propTypes = {
  header: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  footer: PropTypes.objectOf(PropTypes.any).isRequired,
};

export const Gr8piDataTableFooter = ({
  hasNext, hasPrev, onNext, onPrev, text,
}) => (
  <div className="panel-footer text-center">
    <button
      type="button"
      className={hasPrev ? 'pager-item is-active active' : 'pager-item'}
      disabled={!hasPrev}
      onClick={onPrev}
    >
      <i className="fa fa-play fa-rotate-180" aria-hidden="true" />
    </button>
      &nbsp;
    <span className="pager-sep">{text}</span>
      &nbsp;
    <button
      type="button"
      className={hasNext ? 'pager-item is-active active' : 'pager-item'}
      disabled={!hasNext}
      onClick={onNext}
    >
      <i className="fa fa-play" aria-hidden="true" />
    </button>
  </div>
);

Gr8piDataTableFooter.propTypes = {
  hasNext: PropTypes.func,
  hasPrev: PropTypes.func,
  onNext: PropTypes.func,
  onPrev: PropTypes.func,
  text: PropTypes.string.isRequired,
};

Gr8piDataTableFooter.defaultProps = {
  hasNext: null,
  hasPrev: null,
  onNext: null,
  onPrev: null,
};

const messages = defineMessages({
  'attrs.comments': { id: 'attrs.comments', defaultMessage: 'Comments' },
  'attrs.tags': { id: 'attrs.tags', defaultMessage: 'Tags' },
  '360.self': { id: '360.self', defaultMessage: 'Self' },
  '360.managers': { id: '360.managers', defaultMessage: 'Bosses' },
  '360.peers': { id: '360.peers', defaultMessage: 'Peers' },
  '360.directReports': { id: '360.directReports', defaultMessage: 'Direct Reports' },
  '360.others': { id: '360.others', defaultMessage: 'Others' },

  'attrs.fileName': { id: 'attrs.fileName', defaultMessage: 'File Name' },
  'attrs.created.verbose': { id: 'attrs.created.verbose', defaultMessage: 'Created on' },
  'attrs.updated.verbose': { id: 'attrs.updated.verbose', defaultMessage: 'Last update on' },
  'attrs.import.status': { id: 'attrs.import.status', defaultMessage: 'Import Status' },
  'attrs.actions': { id: 'attrs.actions', defaultMessage: 'Actions' },

  'temp.title': { id: 'temp.title', defaultMessage: 'Title' },
  'attrs.name': { id: 'attrs.name', defaultMessage: 'Name' },
  'attrs.email': { id: 'attrs.email', defaultMessage: 'Email' },
  'attrs.created': { id: 'attrs.created', defaultMessage: 'Created' },
  'attrs.created_by': { id: 'attrs.created_by', defaultMessage: 'Created by' },
  'attrs.updated': { id: 'attrs.updated', defaultMessage: 'Updated' },
  'exec_report.mng_team_name': { id: 'exec_report.mng_team_name', defaultMessage: 'Management Team Name' },
  'super_survey.template_label': { id: 'super_survey.template_label', defaultMessage: 'Template' },
});

export const TableHeaderTemplate = (headers, formatMessage) => {
  const headerColumns = headers.map(col => (
    <p className={col.styleClass}>
      {formatMessage(messages[col.textId])}
    </p>
  ));

  return <Gr8piDataTableHeader>{headerColumns}</Gr8piDataTableHeader>;
};

export const getStatusDataTableMap = dataDisplay => ({
  loading: <Loading />,
  noData: <div>No results</div>,
  error: <div>Error</div>,
  normal: dataDisplay,
});

export const Gr8piDataTableFooterWithPageSize = ({
  hasNext,
  hasPrev,
  onNext,
  onPrev,
  text,
  numberPageSize,
  setPageSize,
}) => (
  <div className="panel-footer col-md-12">
    <div className="col-md-4" />
    <div className="col-md-4 text-center">
      <button
        type="button"
        className={hasPrev ? 'pager-item is-active active' : 'pager-item'}
        disabled={!hasPrev}
        onClick={onPrev}
      >
        <i className="fa fa-play fa-rotate-180" aria-hidden="true" />
      </button>
        &nbsp;
      <span className="pager-sep">{text}</span>
        &nbsp;
      <button
        type="button"
        className={hasNext ? 'pager-item is-active active' : 'pager-item'}
        disabled={!hasNext}
        onClick={onNext}
      >
        <i className="fa fa-play" aria-hidden="true" />
      </button>
    </div>
    <div className="col-md-4 text-right">
      {/* {'Show '} */}
      <DropdownButton
        title={(
          <span>
            {' '}
            {numberPageSize}
            {' '}
            <FormattedMessage id="pagination.per_page" defaultMessage="per page" />
          </span>
          )}
        bsStyle="primary"
        pullRight
        id="dropdown-size-extra-small"
        bsSize="small"
        className="lowercase"
      >
        <MenuItem
          eventKey="1"
          onClick={() => setPageSize(Pagination.DEFAULT_PAGE_SIZE_10)}
          className="lowercase"
          active={numberPageSize === Pagination.DEFAULT_PAGE_SIZE_10}
        >
          {Pagination.DEFAULT_PAGE_SIZE_10}
          {' '}
          <FormattedMessage id="pagination.per_page" defaultMessage="per page" />
        </MenuItem>
        <MenuItem
          eventKey="2"
          onClick={() => setPageSize(Pagination.DEFAULT_PAGE_SIZE)}
          className="lowercase"
          active={numberPageSize === Pagination.DEFAULT_PAGE_SIZE}
        >
          {Pagination.DEFAULT_PAGE_SIZE}
          {' '}
          <FormattedMessage id="pagination.per_page" defaultMessage="per page" />
        </MenuItem>
        <MenuItem
          eventKey="3"
          onClick={() => setPageSize(Pagination.DEFAULT_PAGE_SIZE_50)}
          className="lowercase"
          active={numberPageSize === Pagination.DEFAULT_PAGE_SIZE_50}
        >
          {Pagination.DEFAULT_PAGE_SIZE_50}
          {' '}
          <FormattedMessage id="pagination.per_page" defaultMessage="per page" />
        </MenuItem>
        <MenuItem
          eventKey="4"
          onClick={() => setPageSize(Pagination.DEFAULT_PAGE_SIZE_100)}
          className="lowercase"
          active={numberPageSize === Pagination.DEFAULT_PAGE_SIZE_100}
        >
          {Pagination.DEFAULT_PAGE_SIZE_100}
          {' '}
          <FormattedMessage id="pagination.per_page" defaultMessage="per page" />
        </MenuItem>
      </DropdownButton>
      {/* {' entries'} */}
    </div>
  </div>
);

Gr8piDataTableFooterWithPageSize.propTypes = {
  hasNext: PropTypes.func,
  hasPrev: PropTypes.func,
  onNext: PropTypes.func,
  onPrev: PropTypes.func,
  setPageSize: PropTypes.func,
  text: PropTypes.string.isRequired,
  numberPageSize: PropTypes.number,
};

Gr8piDataTableFooterWithPageSize.defaultProps = {
  hasNext: null,
  hasPrev: null,
  onNext: null,
  onPrev: null,
  setPageSize: null,
  numberPageSize: 0,
};


export const Gr8piDataTableStatusIconFilter = ({
  nameTitle, filterClick, iconStatus, intl: { formatMessage },
}) => (
  <div onClick={filterClick} role="button" tabIndex="0">
    <span className="sortable">
      {' '}
      <span>{formatMessage(messages[nameTitle])}</span>
    </span>
    {' '}
    <span className="sortable">
      {iconStatus === null && <i className="fa fa-sort fa-lg fa-default" />}
      {iconStatus === true && <i className="fa fa-sort-up action-icon fa-lg" />}
      {iconStatus === false && <i className="fa fa-sort-down action-icon fa-lg" />}
    </span>
  </div>
);

Gr8piDataTableStatusIconFilter.propTypes = {
  nameTitle: PropTypes.string.isRequired,
  filterClick: PropTypes.func.isRequired,
  iconStatus: PropTypes.bool,
  intl: intlShape.isRequired,
};

Gr8piDataTableStatusIconFilter.defaultProps = {
  iconStatus: null,
};

export const validatePageSize = (queryObject, pageSize, pageSizeLast) => {
  let pageSizenumber = Pagination.DEFAULT_PAGE_SIZE;
  const IsPageSize = queryObject && pageSize ? Pagination.DEFAULT_PAGE_LISTS.indexOf(parseInt(pageSize, 10), 0) : -1;
  // eslint-disable-next-line max-len
  const IsPageSizeLast = queryObject && pageSizeLast ? Pagination.DEFAULT_PAGE_LISTS.indexOf(parseInt(pageSizeLast, 10), 0) : -1;
  if (queryObject && pageSize && IsPageSize !== -1) {
    pageSizenumber = pageSize;
  }
  if (queryObject && pageSizeLast && IsPageSizeLast !== -1) {
    pageSizenumber = pageSizeLast;
  }
  // eslint-disable-next-line max-len
  const pageSizeState = (queryObject && pageSize && IsPageSize !== -1) || pageSizeLast ? pageSize : Pagination.DEFAULT_PAGE_SIZE;
  let pageSizeLastState = null;
  if (queryObject && pageSizeLast) {
    pageSizeLastState = IsPageSizeLast !== -1 && pageSizeLast ? pageSizeLast : Pagination.DEFAULT_PAGE_SIZE;
  }
  const pages = {
    pageSizeLastState,
    pageSizeState,
    pageSizenumber,
  };
  return pages;
};
